<div class="card-container">
  <div class="card-header-wrapper">
    <div class="">
      <div class="row">
        <div class="col-md-12">
          <button
            kendoButton
            (click)="goBack()"
            icon="arrow-chevron-left"
            look="clear"
          >
            Go Back
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h3 class="card-title">Relevant Lab</h3>
        </div>
      </div>
    </div>
  </div>

  <div class="card-component">
    <div class="">
      <div class="row">
        <div class="col-md-4">
          <div class="border-card">
            <p><strong>Name:</strong>> {{ relevantLab.test_name }}</p>
            <p><strong>Date:</strong> {{ relevantLab.test_date }}</p>
            <p>
              <strong>Description:</strong>> {{ relevantLab.test_description }}
            </p>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-6">
          <p><strong>Document files: </strong></p>
          <div
            *ngFor="
              let document of this.relevantLab.documents;
              let labIndex = index;
              trackBy: trackItem
            "
          >
            <div
              class="border-card"
              style="display: flex; justify-content: space-between"
            >
              <p>{{ document.document_name }}</p>
              <button kendoButton (click)="handleDocumentTap(labIndex)">
                View
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
